module.exports = __webpack_public_path__ + "static/media/teen-burger-dt-sept-18_en.d16d6c5b.jpg";